<template>
  <div>
    <ParentRowCard
      :fullname="parent.full_name"
      :image="parent.image"
      :child_count="parent.parentChildren.length"
      :children="parent.parentChildren"
      :email="parent.email"
      :phone="Number(parent.phone)"
      @openParentProfile="toggleProfileCard(index)"
      @toggleMessage="toggleMessageModal"
      v-for="(parent, index) in parents"
      :key="index"
    ></ParentRowCard>

    <!-- PAGINATION COMPONENT -->
    <div class="pagination-section mt-5" v-if="new_page_data.pageCount > 1">
      <Pagination
        :paging="new_page_data"
        @navigatePage="$emit('switchPage', $event)"
      ></Pagination>
    </div>
    <!-- PAGINATION COMPONENT -->

    <!-- MODAL -->
    <ParentProfileCard
      v-if="profile_card"
      :fullname="parents[current_id].full_name"
      :image="parents[current_id].image"
      :email="parents[current_id].email"
      :phone="Number(parents[current_id].phone)"
      :relationship="parents[current_id].parentChildren[0].role"
      :children="parents[current_id].parentChildren"
      @toggleMessage="toggleMessageModal"
      @closeTriggered="toggleProfileCard"
    ></ParentProfileCard>

    <NewMessageModal
      v-if="message_modal"
      @closeTriggered="toggleMessageModal"
    ></NewMessageModal>
    <!-- MODAL -->
  </div>
</template>

<script>
import Pagination from "@/components/globalComps/Pagination";
import ParentRowCard from "@/components/schoolComps/dashboard/parent/ParentRowCard";

export default {
  name: "ParentContentInfo",

  props: {
    parents: Array,
    pagination: Object,
    page_data: Number,
  },

  components: {
    Pagination,
    ParentRowCard,
    ParentProfileCard: () =>
      import(
        /* webpackChunkName: "parentprofilecard" */ "@/components/modalComps/schoolModals/ParentProfileCard"
      ),
    NewMessageModal: () =>
      import(
        /* webpackChunkName: "messagemodal" */ "@/components/modalComps/messageModals/NewMessageModal"
      ),
  },

  data() {
    return {
      new_page_data: this.pagination,
      profile_card: false,
      message_modal: false,
      current_id: null,
    };
  },

  mounted() {},

  watch: {
    page_data: "updatePagination",
  },

  methods: {
    toggleProfileCard(index) {
      this.profile_card = !this.profile_card;
      this.current_id = index;
    },

    toggleMessageModal() {
      this.message_modal = !this.message_modal;
    },

    updatePagination() {
      this.new_page_data = this.pagination;
    },
  },
};
</script>

<style lang="scss">
</style>
